// extracted by mini-css-extract-plugin
export default {"card":"NominatedItem_card__WOtGz","icon":"NominatedItem_icon__04ND3","svg":"NominatedItem_svg__rUKSJ","title":"NominatedItem_title__WWXp4","btn":"NominatedItem_btn__jNIrI"};